import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, UserCode, EmployeeId } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';
import { IsEnglish } from '../../../utils/language';

export function jobTitlesTimesheet() {
    let url = 'timesheet/jobTitles?' + objectToQueryString({ userCode: UserCode(), employeeId: EmployeeId(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let jobTitles = response.jobTitles;

                //saveJobTitles(jobTitles);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortJobTitle(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.jobEn.toLowerCase() : a.jobFr.toLowerCase()
        const nameB = IsEnglish() ? b.jobEn.toLowerCase() : b.jobFr.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function sortJobTitleByCode(data) {
    return data?.sort(function (a, b) {
        const nameA = a.jc
        const nameB = b.jc
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}